<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết công việc của CSKH</h1>
      <div class="btn-group float-right">
        <button
          @click="approve()"
          v-if="
            (dataPermission.includes('CNPS_CSS_TASK_MKT_APPROVE') &&
              item.approvedStatus === 'WAIT_APPROVED') ||
            !item.approvedStatus
          "
          class="f12 font-medium btn btn-outline-primary"
        >
          Duyệt
        </button>
        <button
          @click="reject"
          v-if="
            (dataPermission.includes('CNPS_CSS_TASK_MKT_APPROVE') &&
              item.approvedStatus === 'WAIT_APPROVED') ||
            !item.approvedStatus
          "
          class="f12 font-medium btn btn-outline-secondary"
        >
          Từ chối
        </button>
        <button
          @click="edit"
          v-if="
            (dataPermission.includes('CNPS_CSS_TASK_MKT_UPDATE') &&
              item.approvedStatus === 'WAIT_APPROVED') ||
            !item.approvedStatus
          "
          class="f12 font-medium btn btn-outline-secondary"
        >
          {{ isEdit ? 'Lưu' : 'Sửa' }}
        </button>
        <button @click="handleRouter" class="f12 font-medium btn btn-outline-secondary">
          <i class="bx bx-left-arrow-alt"></i>
          {{ isEdit ? 'Bỏ qua' : 'Quay lại' }}
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20">
        <b-row>
          <b-col cols="10" md="6">
            <div class="mb-3">
              <div class="form-detail">
                <h1>Thông tin chung</h1>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Merchant<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ item.merchantOwnerInfo?.ownerName || '' }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Tên Sale<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ item.handlerRes?.name }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Người duyệt<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ item.approvedName }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Thời gian tạo<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ item.createdTime | formatDate('HH:mm, DD/MM/YYYY') }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Thời gian hoàn thành<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ item.endProcessing | formatDate('HH:mm, DD/MM/YYYY') }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Thời gian duyệt<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ item.approvedDate | formatDate('HH:mm, DD/MM/YYYY') }}
                    </p>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Trạng thái<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      <b-badge :variant="getStatusBadge(item.approvedStatus)">
                        {{ getStatusName(item.approvedStatus) }}
                      </b-badge>
                    </p>
                  </div>
                </div>
                <div v-if="item.approvedStatus === 'REJECTED'" class="form-group form-row">
                  <label for="" class="col-sm-4 col-form-label"
                    >Lý do<span class="float-right">:</span></label
                  >
                  <div class="col-sm-8">
                    <p class="form-control-plaintext f12">
                      {{ item.reasonReject }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-detail">
              <h1>Lịch sử duyệt</h1>

              <b-table
                :busy.sync="isLoading"
                sticky-header
                responsive
                hover
                :items="dataHistory"
                :fields="fieldsTable"
                :fixed="true"
                :bordered="true"
              >
                <template #table-busy>
                  <div class="text-center my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <template #cell(createdByName)="{ item }">
                  <p>{{ item?.createdByName }}</p>
                  <b-link :href="`mailto:${item?.createdByEmail}`">{{
                    item?.createdByEmail
                  }}</b-link>
                </template>

                <template #cell(status)="{ item }">
                  <p>{{ getStatusName(item?.status) }}</p>
                </template>
              </b-table>
            </div>
          </b-col>
          <b-col cols="10" md="6">
            <div v-for="(task, index) in item.formDataList" :key="`task-${index}`">
              <div class="form-detail">
                <div class="img-list-wrapper mb-2">
                  <h1 class="form-inner-heading">{{ task.formName }}</h1>
                  <div>
                    <div>
                      <div class="form-group">
                        <ul class="ml-2" v-viewer>
                          <li
                            class="mb-3"
                            v-for="(taskDetail, index1) in task.taskInFormDataList"
                            :key="`taskDetail-${index}-${index1}`"
                            style="gap: 10px"
                          >
                            <div class="font-size-14 font-medium mb-2">
                              {{ taskDetail?.taskInFormName }}
                            </div>
                            <div class="list-images">
                              <div
                                v-for="(src, index2) in taskDetail.images"
                                :key="`imageDetail-${index}-${index1}-${index2}`"
                                class="pos-relative"
                                style="width: 100px"
                              >
                                <a href="javascript:void(0)">
                                  <img class="task-img" :src="src" alt="task-img" />
                                </a>
                                <span
                                  class="icon-delete cursor-pointer"
                                  v-if="isEdit === true"
                                  @click="
                                    removeFile(`${index}-${index1}-${index2}`, task?.formCode)
                                  "
                                  ><i class="bx bx-trash bx-sm"></i
                                ></span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row> </b-row>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="isLoading" :is-full-page="true"> </VueLoadingOverlay>

    <b-modal id="modal-scoped" v-model="showModal" @hide="handleCloseReject">
      <template #modal-header="{ close }">
        <h5>Bạn chắc chắn muốn từ chối?</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="">
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(handleReject)">
            <div class="font-size-14 font-medium mb-2">Lý do từ chối:</div>
            <b-form-checkbox-group
              id="reasons"
              name="reasons"
              aria-label="List Reasons"
              stacked
              class="group-cb"
              v-model="selectedReasons"
              @change="changeSelectedReason"
            >
              <b-form-checkbox
                v-for="(reason, index) in mktRejectReasons"
                :key="index"
                :value="reason"
              >
                <span style="line-height: 24px">{{ reason }}</span>
              </b-form-checkbox>
            </b-form-checkbox-group>
            <span class="text-danger">{{ emptySelected }}</span>
            <ValidationProvider
              rules="required|minMaxName_4"
              name="Lý do từ chối"
              v-slot="{ errors }"
            >
              <b-form-group label="" label-for="floatingTextarea2">
                <b-form-textarea
                  v-if="selectedReasons?.includes('Khác')"
                  id="floatingTextarea2"
                  v-model="reason"
                  placeholder="Lý do"
                  rows="3"
                  max-rows="6"
                  :state="errors.length > 0 ? false : null"
                >
                </b-form-textarea>
                <b-form-invalid-feedback id="input-live-feedback">{{
                  errors[0]
                }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </form>
        </ValidationObserver>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()"> Huỷ bỏ </b-button>
        <b-button size="sm" variant="primary" @click="handleReject"> Đồng ý </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { cskhApprove, cskhUpdate, GetHistory, getCskh } from '@/services/sticker-standee.service'
  import Config from '@/thirdParty/config'
  import { mapGetters } from 'vuex'
  import { CommonService } from '@/services/common.service'
  import moment from 'moment'

  const fieldsTable = [
    {
      key: 'createdDate',
      label: 'Thời gian',
      class: 'text-left',
      formatter: value => {
        return moment(value).format('HH:mm DD/MM/YYYY')
      },
    },
    { key: 'createdByName', label: 'Người thực hiện' },
    { key: 'status', label: 'Loại hành động' },
    { key: 'reason', label: 'Lý do' },
  ]

  export default {
    data() {
      return {
        dataHistory: [],
        fieldsTable,
        actionMap: [
          { id: 'REJECTED', name: 'Từ chối' },
          { id: 'APPROVED', name: 'Duyệt' },
        ],
        showModal: false,
        isEdit: false,
        canSave: false,
        Config,
        item: {},
        isLoading: false,
        mktRejectReasons: [],
        selectedReasons: [],
        reason: '',
        emptySelected: '',
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    async created() {
      if (this.dataPermission.includes('CNPS_CSS_TASK_MKT_DETAIL')) {
        try {
          this.isLoading = true
          await this.configSystem()
          await this.fetchData()
          await this.loadDataHistory()
        } catch (error) {
        } finally {
          this.isLoading = false
        }
      } else {
        this.$bvModal
          .msgBoxOk('Bạn không có quyền truy cập vào trang này', {
            title: 'Cảnh báo',
            okVariant: 'danger',
            headerClass: 'p-2 border-bottom-0',
            footerClass: 'p-2 border-top-0',
            centered: true,
          })
          .then(() => {
            this.$router.replace('/')
          })
      }
    },
    methods: {
      configSystem() {
        this.isLoading = true
        return CommonService.getConfigSystem()
          .then(data => {
            if (data.success) {
              this.mktRejectReasons = data.data.mktRejectReasons
            }
            this.isLoading = false
          })
          .catch(error => {
            this.isLoading = false
            console.error(error)
          })
      },
      changeSelectedReason(val) {
        if (val?.length) {
          this.emptySelected = ''
        }
      },
      async loadDataHistory() {
        try {
          const res = await GetHistory(this.$route.params.id)
          if (res.code === 1000) {
            this.dataHistory = res.data
          } else {
            this.showFailMx(res.message)
          }
        } catch (e) {
          this.showFailMx(e.response?.data?.message ? e.response.data.message : e.message)
        }
      },
      getStatusName(id) {
        const status = Config.statusCskhJob.find(status => status.id === id)
        return status ? status.text : 'Chưa duyệt'
      },
      getStatusBadge(id) {
        const status = Config.statusCskhJob.find(status => status.id === id)
        return status ? status.badge : 'warning'
      },
      async fetchData() {
        try {
          this.isLoading = true
          const res = await getCskh(this.$route.params.id)
          this.item = res.data
        } catch (e) {
          this.showFailMx(e.response?.data?.message ? e.response.data.message : e.message)
        } finally {
          this.isLoading = false
        }
      },
      async approve() {
        const flag = await this.approveMx('Bạn có chắc chắn muốn duyệt công việc trên')
        if (flag === true) {
          try {
            this.isLoading = true
            const res = await cskhApprove({
              taskId: this.$route.params.id,
              action: 'APPROVED',
            })
            if (res.result) {
              await this.fetchData()
              this.showSuccessMx('Duyệt công việc thành công')
            } else this.showFailMx(res.message)
          } catch (e) {
            this.showFailMx(e.response?.data?.message ? e.response.data.message : e.message)
          } finally {
            this.isLoading = false
          }
        }
      },
      async reject() {
        this.showModal = true
      },
      async handleReject() {
        if (this.selectedReasons.length === 0) {
          this.emptySelected = 'Vui lòng chọn ít nhất 1 lý do từ chối'
          return
        }

        if (this.selectedReasons?.includes('Khác')) {
          const isValid = await this.$refs.observer.validate()
          if (!isValid) return
        }

        const reasons =
          this.selectedReasons.filter(reason => reason !== 'Khác').join('; ') +
          (this.selectedReasons.includes('Khác') ? '; ' + this.reason : '')

        this.showModal = false
        try {
          this.isLoading = true
          const res = await cskhApprove({
            taskId: this.$route.params.id,
            action: 'REJECTED',
            reason: reasons,
          })
          if (res.result) {
            await this.fetchData()
            this.showSuccessMx('Từ chối công việc thành công')
          } else this.showFailMx(res.message)
        } catch (e) {
          this.showFailMx(e.response?.data?.message ? e.response.data.message : e.message)
        } finally {
          this.isLoading = false
        }
      },
      removeFile(key, taskFormCode) {
        let maxLength = 2
        if (taskFormCode === 'STICKER_AMEX') {
          maxLength = 1
        }
        // allow remove if images > 2
        const [taskIndex, taskDetailIndex, imageIndex] = key.split('-')
        const images = this.item.formDataList[taskIndex].taskInFormDataList[taskDetailIndex].images
        if (images.length > maxLength) {
          images.splice(imageIndex, 1)
          this.canSave = true
        } else {
          this.showFailMx(
            `Thông tin chăm sóc [LOẠI ${taskFormCode}] cần tối thiểu ${maxLength} ảnh`
          )
        }
      },
      handleRouter() {
        if (this.isEdit) {
          this.isEdit = false
          this.canSave = false
        } else {
          const activeTab = this.$route.query.tab || 0
          this.$router.push({
            path: '/sticker-standee/sale',
            query: { tab: activeTab },
          })
        }
      },
      handleCloseReject() {
        this.reason = ''
        this.selectedReasons = []
        this.emptySelected = ''
      },
      async edit() {
        if (this.isEdit === false) {
          this.isEdit = true
        } else {
          if (!this.canSave) {
            return
          }
          try {
            this.isLoading = true
            const res = await cskhUpdate({
              taskId: this.$route.params.id,
              formDataList: this.item.formDataList,
            })
            if (res.result) {
              await this.fetchData()
              this.isEdit = false
              this.canSave = false
              this.showSuccessMx('Cập nhật công việc thành công')
            } else this.showFailMx(res.message)
          } catch (e) {
            this.showFailMx(e.response?.data?.message ? e.response.data.message : e.message)
          } finally {
            this.isLoading = false
          }
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  .task-img {
    width: 100px !important;
    border: 1px solid;
    border-radius: 4px;
  }
  .icon-delete {
    position: absolute;
    top: 0;
    right: 0;
  }
  .bx-trash {
    color: red;
  }

  .list-images {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .group-cb {
  }
</style>
